import { Pipe, PipeTransform } from '@angular/core';
import { StateEnum } from '@core/enums';

@Pipe({
  name: 'statusFormat'
})
export class StatusFormatPipe implements PipeTransform {
  transform(value: string | null): string | null {
    switch (value) {
      case StateEnum.Active:
        return 'Active';
      case StateEnum.Inactive:
        return 'Inactive';
      case StateEnum.Finished:
        return 'Terminated';
      default:
        return value;
    }
  }
}